var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between text-xs font-bold border rounded border-gray-300 h-8 w-14 px-1.5"},[_c('img',{attrs:{"src":require("@/assets/icons/star-full-yellow.svg"),"alt":"Star","height":"12","width":"12"}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.rating)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }